import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { contentHeaders, apiBaseUrl } from "../common/config/config";
import { ActionSheetController, Platform, LoadingController, ToastController } from "@ionic/angular";
import { Preferences } from '@capacitor/preferences';
import { Geolocation } from "@capacitor/geolocation";
import { Motion } from "@capacitor/motion";
import { ReportService } from './report';
// import { BackgroundGeolocationPlugin } from "@capacitor-community/background-geolocation";
import {registerPlugin} from "@capacitor/core";
// const BackgroundGeolocation = registerPlugin("BackgroundGeolocation");

@Injectable({
  providedIn: 'root'
})
export class DeviceMotionService {
  public sampleSet = [];
  private max = 0;
  lStepCount = 0;
  lDirection = 0;
  direction = 0;
  private observable: any;
  private subscription: any;
  public currentStepCount = 0;
  public history = [];
  private tolerance = 0.3;
  private bufferTime = 500;
  private bufferGrain = 100;
  private bufferSize = 50;
  public lastTs: number;
  public data: any;
  public orientationdata: any;
  constructor (
    public http: HttpClient, 
    public platform: Platform,
    public toaster: ToastController,
    private reports:ReportService
  ) { 
    // this.startStepCount()
  }
  
  getString() {
    return JSON.stringify(this.orientationdata);
  }

  //step counting initiater funtion
  async startStepCount() {
    // Background Tracking
    // console.log("Step Counting Started");
    this.currentStepCount = 0;
    this.sampleSet = [];
    this.reports.walkDirection = [];
    this.subscription = await Motion.addListener('accel', (data) => {
      // console.log(data, "motion accel");
      if (!this.lastTs) this.lastTs = data.interval;
      this.data = data.acceleration;
      this.orientationdata = data.accelerationIncludingGravity;
      this.sampleSet.push(Math.sqrt(data.acceleration.x * data.acceleration.x + data.acceleration.y * data.acceleration.y + data.acceleration.z * data.acceleration.z));
      this.sampleSet.length >= this.bufferSize ? this.digest() : "";
      this.update();
    });
    console.log("motion record", this.subscription);
  }
  update() {
    // console.log(this.orientationdata);
    if (this.orientationdata.x > 8) {
      this.direction = 180 + Math.atan2(this.orientationdata.y, this.orientationdata.z) * (180 / Math.PI);
      this.lDirection = this.direction;
    } else if (this.orientationdata.y > 8) {
      this.lDirection = 360 - (180 + Math.atan2(this.orientationdata.x, this.orientationdata.z) * (180 / Math.PI));
    } else if (this.orientationdata.z > 8) {
      this.lDirection = (180 + Math.atan2(this.orientationdata.x, this.orientationdata.y) * (180 / Math.PI) + 90) % 360;
    }
    if (this.currentStepCount > this.lStepCount) {
      this.lStepCount = this.currentStepCount;
      this.reports.walkDirection.push(this.lDirection);
    }
  }
  lastTimeC = null;
  checkStellment() {
    return this.lastTimeC + 1000 <= Date.now();
  }
  //digest cycle method for processing data
  digest() {
    let min = 100,
      max = -100,
      mean,
      diff = 0;
    //calculating moving mean by dynamically updating minimum and maximum values
    this.sampleSet.forEach((sample) => {
      min = Math.min(sample, min);
      max = Math.max(sample, max);
    });
    mean = (max + min) / 2;
    var j = 0;
    //running deviation test cycle to observe high slew zero cross events around the mean
    for (var i = 0; i < this.sampleSet.length; i++) {
      let previousDiff = diff;
      diff = this.sampleSet[i] - mean;
      if ((diff > this.tolerance && previousDiff <= -this.tolerance) || (diff <= -this.tolerance && previousDiff > this.tolerance)) {
        if (j == 0 && this.checkStellment()) {
          this.currentStepCount++;
          j = this.bufferGrain / 10;
        } else {
          if (j > 0) j--;
          if (this.tolerance < 0.9) this.tolerance += 0.05;
        }
        this.lastTimeC = Date.now();
        //i = i+(this.bufferGrain/10);
      } else {
        if (j > 0) j--;
        if (this.tolerance > 0.4) this.tolerance -= 0.01;
      }
    }
    // flushing sampleset
    this.sampleSet.splice(0, this.sampleSet.length);
  }
  reset(){
    if(this.sampleSet.length > 0){
      this.lStepCount = 0;
      this.lDirection = 0;
      this.direction = 0;
      this.currentStepCount = 0;
      this.sampleSet = [];
      this.reports.walkDirection = [];
    } else {
      this.startStepCount();
    }
  }
  // lapStepCount() {
  //   this.history.push(this.currentStepCount);
  //   this.currentStepCount = 0;
  //   return this.history[this.history.length - 1];
  // }

  //unsubscribe device motion observable
  async stopStepCount() {
    await Motion.removeAllListeners(); 
    this.lStepCount = 0;
    this.lDirection = 0;
    this.direction = 0;
    this.sampleSet = [];
  }
}
